import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Email from '@/pages/auth/LoginScreens/Email';
import SelectOrganization from '@/pages/auth/LoginScreens/SelectOrganization';
import CenterConatainer from '@/components/layouts/CenterContainer';
import LogoHeader from '@/components/layouts/LogoHeader';
import { fetchConfig } from '@/services/setting.service';
import { HEADINGS } from '@/utils/constants/appConstants/commonConstants';
import { verifyEmail } from '@/services/auth.service';
import { setFeaturesListInLocalStorage, storeLoginUserData } from '@/utils/functions/helperFunctions';
import { getCurrentOrganization, setCurrentOrganization } from '@/utils/functions/OrganizationFunctions';
import { ORG_DOMAIN_RESTRICTED } from '@/utils/constants/messages';
import { getemail_address } from '@/utils/functions/TokenFunction';

const LoginMain = () => {
    const [loginState, setLoginState] = useState('email');
    const navigate = useNavigate();
    useEffect(() => {
        
        setFeaturesListInLocalStorage()
    }, []);
    const handleEmail = (data: any, callback: any, errcallback: any) => {
        verifyEmail(
            data,
            (res: any) => {
                storeLoginUserData(res)
                if (res.organizations.filter((org: any) => org.is_active).length > 1) {
                    callback(res);
                    setLoginState('organization')
                } else {
                    setCurrentOrganization(res.organizations.filter((org: any) => org.is_active)[0])
                    callback(res);
                    fetchConfig(
                        {id: getCurrentOrganization().organization},
                        (res: any) => {
                            localStorage.removeItem('sso_login_restricted')
                            localStorage.removeItem('sso_login_enabled')
                            if(res?.is_directory_service_enabled) {
                                localStorage.setItem('sso_login_enabled', JSON.stringify(res?.is_directory_service_enabled));
                                if(res?.is_restrict_login_with_sso) {
                                    localStorage.setItem('sso_login_restricted', JSON.stringify(res?.is_restrict_login_with_sso));
                                }
                            }
                            navigate('/login');
                        }, (err: any) => {
                            errcallback(err)
                        }
                    );
                }
            },
            (err: any) => errcallback(err)
        );
    };

    const handleOrganization = (currentOrg: string, callback: any, errcallback: any, setErr: any) => {
        fetchConfig(
            {id: currentOrg},
            (res: any) => {
                callback(res);
                localStorage.removeItem('sso_login_restricted')
                localStorage.removeItem('sso_login_enabled')
                if(res?.is_directory_service_enabled) {
                    localStorage.setItem('sso_login_enabled', JSON.stringify(res?.is_directory_service_enabled));
                    if(res?.is_restrict_login_with_sso) {
                        localStorage.setItem('sso_login_restricted', JSON.stringify(res?.is_restrict_login_with_sso));
                    }
                }
                if (res?.is_signup_domain_restricted) {
                    const email_domain = getemail_address()?.split('@')[1].toLowerCase()
                    const allowed_domains = res?.allowed_domains && res?.allowed_domains.map((domain: string) => domain.toLowerCase())
                    if (allowed_domains.length > 0 && !allowed_domains.includes(email_domain)) {
                        setErr(ORG_DOMAIN_RESTRICTED(res?.allowed_domains.join(', ')));
                        return
                    }
                }
                navigate('/login');
            }, (err: any) => {
                setLoginState('email')
                errcallback(err)
            }
        );
    };

    return (
        <CenterConatainer>
            <LogoHeader id={'login-form'} heading={HEADINGS.LOGIN} children={undefined} />
            {loginState === 'email' ? <Email handleEmail={handleEmail} /> : <SelectOrganization handleOrganization={handleOrganization} />}
        </CenterConatainer>
    );
};

export default LoginMain;
